import { buildActivateEvent } from "./activateEvent";
import { buildConversionEvent } from "./conversionEvent";

import { ACTIVATE_EVENT_KEY } from "../../constants/config";
import { EventBuilder } from "../../typings";

export const v1EventBuilder: EventBuilder = (input) => {
  const { eventKey } = input;

  const isActivateEvent = eventKey === ACTIVATE_EVENT_KEY;

  return isActivateEvent
    ? buildActivateEvent(input)
    : buildConversionEvent(input);
};
